export default __webpack_public_path__ + "static/media/job_offer10_m.3d55b051.jpg";